
/*
 * @author          Riddhi D Parekh
 * @date            19th November 2018
 * @type            Survey Questions store File
 * @description -   This file has methods to retrieve and edit save questions of a survey
 *
 */
var { queControlConfig } = require('../../../../config/config.js')
var { queTypeConfig } = require('../../../../config/config.js')
var { queValidationConfig } = require('../../../../config/config.js')

function initialState () {
  return {
    surveyQuestions: [],
    questionAll: [],
    surveyStartEndQuestions: [],
    copyQuestionAll: [],
    surveyQuestionWithDetails: {},
    SurveyQuestionAnswerWithScore: {},
    questionUpdated: 0,
    relationships: {},
    query: {},
    loading: false,
    loadingAllSurveyDetails: false,
    surveyAudit: 0,
    calledBefore: false,
    skipLogicRetrieved: false,
    isSkipLogic: false,
    skipLogicDetails: {},
    skipLogicKey: 0,
    currentQno: 0,
    skipLogicStartQ: -4,
    skipLogicEndQ: -4,
    skipLogicEndScreen: false,
    skipLogicQids: [],
    isFullScreen: false,
    ruleCreatedIds: [],
    excelDataArray: [],
    ExcelQuestionMasterId:null,
    AnswersWithTagsDetail:''
  }
}
const getters = {
  surveyQuestions: state => {
    let rows = state.surveyQuestions
    return rows
  },
  getQuestionAll: state => {
    let rows = state.questionAll
    return rows
  },
  surveyStartEndQuestions: state => {
    let rows = state.surveyStartEndQuestions
    return rows
  },
  getCopyQuestionAll: state => {
    let rows = state.copyQuestionAll
    return rows
  },
  isFullScreen: state => state.isFullScreen,
  calledBefore: state => state.calledBefore,
  skipLogicRetrieved: state => state.skipLogicRetrieved,
  skipLogicKey: state => state.skipLogicKey,
  skipLogicStartQ: state => state.skipLogicStartQ,
  skipLogicEndQ: state => state.skipLogicEndQ,
  skipLogicEndScreen: state => state.skipLogicEndScreen,
  skipLogicQids: state => {
    let rows = state.skipLogicQids
    return rows
  },
  ruleCreatedIds: state => {
    let rows = state.ruleCreatedIds
    return rows
  },
  currentQno: state => state.currentQno,
  isSkipLogic: state => state.isSkipLogic,
  getSurveyQuestWithDetails: state => state.surveyQuestionWithDetails,
  getSkipLogicDetails: state => state.skipLogicDetails,
  getSurveyQuestionAnswerWithScore: state =>
    state.SurveyQuestionAnswerWithScore,
  total: state => state.length,
  loading: state => state.loading,
  loadingAllSurveyDetails: state => state.loadingAllSurveyDetails,
  surveyAudit: state => state.surveyAudit,
  questionUpdated: state => state.questionUpdated,
  relationships: state => state.relationships,
  excelDataArray: state => state.excelDataArray,
  ExcelQuestionMasterId : state => state.ExcelQuestionMasterId,
  AnswersWithTagsDetail : state => state.AnswersWithTagsDetail
}
const actions = {
  // get data for edit question
  async getSurveyData ({ commit, state }, surveyData) {
    if (surveyData.in_survey_Id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = surveyData['jwt_token']
      let url = process.env.API_PATH + '/getAllSurveyQuestionBySurveyId'
      await axios
        .post(
          url,
          {
            lang: surveyData['lang'],
            request_id: surveyData['requestId'],
            in_survey_Id: surveyData['in_survey_Id']
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        .then(response => {
          if (response.data.flag) {
            commit('setsurveyQuestions', response.data.data)
          } else {
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },

  async getSurveyQuestionAnswerWithTags ({ commit, state }, answerData) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = answerData['sessionData']['jwt_token']
      let url = process.env.API_PATH + '/getAnswersWithTagsDetail'
      await axios
        .post(
          url,
          {
            lang: answerData['sessionData']['lang'],
            request_id: answerData['sessionData']['requestId'],
            in_question_master_id : answerData['in_question_master_id'],
            in_question_type_id: answerData['in_question_type_id']
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        .then(response => {
            response = Object.values(response.data.answer_data);
            commit('setAnswersWithTagsDetail', response);
        })
        .catch(error => { })
        .finally(() => {
          commit('setLoading', false)
        })
  },
  clearAnswersWithTagsDetail({commit}){
    commit('clearAnswersWithTagsDetail',[]);
  },
  // create default question
  async createData ({ commit, state }, questionData) {
    let inVal = 0
    if (
      questionData.in_question_type_id == queTypeConfig.TYPE_MULTIPLE_TEXT
        ? (inVal = 1)
        : questionData.in_question_type_id == queTypeConfig.TYPE_CURRENCY
          ? (inVal = 2)
          : questionData.in_question_type_id == queTypeConfig.TYPE_TRUE_FALSE
            ? (inVal = 3)
            : ''
    ) {
    }
    axios.defaults.headers.common['Authorization'] = questionData['jwt_token']
    let url = process.env.API_PATH + '/addSurveyQuestion'
    await axios
      .post(
        url,
        {
          lang: questionData['lang'],
          request_id: questionData['requestId'],
          sessionData: questionData['sessionData'],
          in_survey_Id: questionData['in_survey_Id'],
          st_question_title: questionData['st_question_title'],
          in_question_type_id: questionData['in_question_type_id'],
          in_question_number: questionData['in_question_number'],
          in_question_order: questionData['in_question_order'],
          inEmailDatePhoto: inVal,
          in_added_by: questionData['requestId']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        if (response.data.flag === 0) {
        } else if (response.data.flag === 1) {
          commit('setQuestionId', response.data)
          commit('setSurveyQuestWithDetails', response.data)
          response.data['in_control_id'] = questionData['in_question_type_id']
          response.data['st_control_name'] = questionData['st_control_name']
          response.data['st_class_name'] = questionData['st_class_name']
          if (
            questionData['in_question_type_id'] ==
              queControlConfig.CONTROL_START_SCREEN ||
            questionData['in_question_type_id'] ==
              queControlConfig.CONTROL_END_SCREEN
          ) {
            commit('setsurveyStartEndQuestionsAfterCreate', response.data)
          } else {
            commit('updateSurveyQuestions', response.data)
          }
        } else {
        }
      })
      .catch(e => {
        // this.$awn.alert(this.$t('message.catchapiError'))
        console.log(e)
      })
  },
  // get data for start end screen of survey
  async getSurveyStartEndData ({ commit, state }, surveyData) {
    if (surveyData.in_survey_Id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = surveyData['jwt_token']
      let url = process.env.API_PATH + '/getStartEndScreenBySurveyId'
      await axios
        .post(
          url,
          {
            lang: surveyData['lang'],
            request_id: surveyData['requestId'],
            in_survey_Id: surveyData['in_survey_Id']
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        .then(response => {
          if (response.data.flag && response.data.data) {
            commit('setsurveyStartEndQuestions', response.data.data)
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },
  // set question order for survey questions
  async setSurveyQuestionsOrder ({ commit, state }, surveyData) {
    if (surveyData.in_survey_Id) {
      // commit('setCancelSource')
      // if (state.cancelSource) {

      //   state.cancelSource.cancel('Operation canceled by the user.')
      // }
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = surveyData['jwt_token']
      let url = process.env.API_PATH + '/setSurveyQuestionsOrder'
      await axios
        .post(
          url,
          {
            lang: surveyData['lang'],
            request_id: surveyData['requestId'],
            in_survey_Id: surveyData['in_survey_Id'],
            questionIdsArray: surveyData['questionDetails']
          },
          {
            cancelToken: state.cancelSource ? state.cancelSource.token : ''
          }
        )
        .then(response => {
          if (response.data.flag) {
            // commit('setCancelSource')
            commit('setsurveyQuestionsOrder', surveyData['questionDetails'])
          } else {
          }
        })
        .catch(error => {
          if (axios.isCancel(error)) {
          } else {
            // handle error
          }
        })
        .finally(() => {
          commit('setLoading', false)
        })

      // source.cancel('Start new search, stop active search')
    }
  },
  // get data for edit question
  getEditData ({ commit, state }, questionData) {
    if (questionData['sessionData'].in_survey_Id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] =
        questionData['sessionData']['jwt_token']
      let url = process.env.API_PATH + '/getSurveyQuestionById'
      axios
        .post(
          url,
          {
            lang: questionData['sessionData']['lang'],
            request_id: questionData['sessionData']['requestId'],
            in_survey_Id: questionData['sessionData']['in_survey_Id'],
            in_question_master_id: questionData['in_question_master_id']
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        .then(response => {
          if (response.data.flag) {
            commit('setQuestionAll', response.data.data[0])
            commit('setSurveyQuestWithDetails', response.data.data[0])
          } else {
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },
  // get all survey questions with details
  getSurveyQuestionWithDetails ({ commit, state }, questionData) {
    if (questionData.in_survey_Id) {
      commit('setLoading', true)
      commit('setLoadingAllSurveyDetails', true)
      axios.defaults.headers.common['Authorization'] =
        questionData['jwt_token']
      let url = process.env.API_PATH + '/getAllQuestionDetailsBySurveyId'
      axios
        .post(
          url,
          {
            lang: questionData['lang'],
            request_id: questionData['requestId'],
            in_survey_Id: questionData['in_survey_Id']
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        .then(response => {
          if (response.data.flag) {
            commit('setSurveyQuestionWithDetails', response.data.data)
          } else {
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
          commit('setLoadingAllSurveyDetails', false)
        })
    }
  },
  // get particular question details if collapse clicked before completion of retrieving all question details
  getSurveyQuestWithDetailsByQuestionId ({ commit, state }, questionData) {
    if (questionData.in_survey_Id && questionData.in_question_master_id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] =
        questionData['jwt_token']
      let url =
        process.env.API_PATH + '/getSurveyQuestionWithDetailsByQuestionId'
      axios
        .post(
          url,
          {
            lang: questionData['lang'],
            request_id: questionData['requestId'],
            in_survey_Id: questionData['in_survey_Id'],
            in_question_master_id: questionData['in_question_master_id']
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        .then(response => {
          if (response.data.flag) {
            commit('setSurveyQuestWithDetails', response.data)
          } else {
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },

  // save question answer score details
  editSurveyAnswerWithScore ({ commit, state }, questionData) {
    if (questionData.in_survey_question_answer_id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] =
        questionData['jwt_token']
      let url = process.env.API_PATH + '/editSurveyQuestionAnswerWithScore'
      axios
        .post(
          url,
          {
            lang: questionData['lang'],
            request_id: questionData['requestId'],
            in_question_type_id: questionData['in_question_type_id'],
            in_survey_question_answer_id:
              questionData['in_survey_question_answer_id'],
            st_answer_score: questionData['st_answer_score'],
            other_score: questionData['otherScore'],
            in_survey_Id: questionData['in_survey_Id']
          },
          { headers: { 'Content-Type': 'application/json' } }
        )
        .then(response => {
          if (response.data.flag) {
            response.data.data.in_question_type_id =
              questionData['in_question_type_id']
            commit('setSurveyQuestionAnswerWithScore', response.data.data)
            commit('setScoreInExpandData', response.data.data)
          } else {
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },
  // save question answer score with multiple details
  async editSurveyAnswerWithMultipleScores ({ commit, state }, questionData) {
    if (questionData.score_data) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] =
        questionData['jwt_token']
      let url = process.env.API_PATH + '/editSurveyQuestionAnswerWithScore'
      await axios
        .post(
          url,
          {
            lang: questionData['lang'],
            request_id: questionData['requestId'],
            in_question_type_id: questionData['in_question_type_id'],
            score_data: questionData['score_data'],
            in_survey_Id: questionData['in_survey_Id']
          },
          { headers: { 'Content-Type': 'application/json' } }
        )
        .then(response => {
          if (response.data.flag) {
            response.data.data.in_question_type_id =
              questionData['in_question_type_id']
            response.data.data.score_data = questionData['score_data']
            // commit('setSurveyQuestionAnswerWithScore', response.data.data)
            commit('setScoreInExpandData', response.data.data)
          } else {
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },
  // get question answer score details
  async getSurveyAnswerWithScore ({ commit, state }, questionData) {
    if (questionData.in_survey_question_answer_id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] =
        questionData['jwt_token']
      let url = process.env.API_PATH + '/getSurveyQuestionAnswerWithScore'
      await axios
        .post(
          url,
          {
            lang: questionData['lang'],
            request_id: questionData['requestId'],
            in_survey_question_answer_id:
              questionData['in_survey_question_answer_id']
          },
          { headers: { 'Content-Type': 'application/json' } }
        )
        .then(response => {
          if (response.data.flag) {
            commit('setSurveyQuestionAnswerWithScore', response.data.data)
          } else {
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },
  // remove question from audit
  async removeAuditFromSurveyQuestion ({ commit, state }, questionData) {
    if (questionData.in_question_master_id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] =
        questionData['jwt_token']
      let url = process.env.API_PATH + '/removeAuditInSurveyQuestion'
      await axios
        .post(
          url,
          {
            lang: questionData['lang'],
            request_id: questionData['requestId'],
            in_question_master_id: questionData['in_question_master_id'],
            in_survey_Id: questionData['in_survey_Id']
          },
          { headers: { 'Content-Type': 'application/json' } }
        )
        .then(response => {
          if (response.data.flag) {
          } else {
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },
  // save edit question data
  async saveData ({ commit, state }, questionData) {
    var validationDetailsArray = []
    var allowChars = ''
    var allowCharsIndex = -1
    var inAddress = 0

    let i = 0
    Object.keys(questionData.validationDetails).forEach((key, index) => {
      if (key == 'imageArray') {
        questionData.validationDetails[key].forEach((value, index1) => {
          validationDetailsArray[i] = {
            in_question_validation_id: queValidationConfig.VALIDATION_IMAGE,
            validationValue: {
              st_answer_text: value
            }
          }
          i++
        })
      } else if (
        key == 'childVid' &&
        (questionData.in_question_type_id == queTypeConfig.TYPE_INPUT ||
          questionData.in_question_type_id ==
            queTypeConfig.TYPE_END_SCREEN_TEXT ||
          questionData.in_question_type_id ==
            queTypeConfig.TYPE_END_SCREEN_IMAGE)
      ) {
        validationDetailsArray[i] = {
          in_question_validation_id: questionData.validationDetails[key],
          validationValue: {
            st_answer_text: 1
          }
        }
        i++
      } else if (key.indexOf('allowChar') >= 0) {
        // if (questionData.validationDetails[key] == true && (questionData['allowedValidations'].indexOf(parseInt(key.split(' ')[0])) > -1)) {

        var arr = key.split(' ')
        if (arr[2] == '') {
          allowChars += ' ' + 'sep'
        } else {
          allowChars += arr[2] + 'sep'
        }
        allowCharsIndex === -1 ? ((allowCharsIndex = i), i++) : ''
        validationDetailsArray[allowCharsIndex] = {
          in_question_validation_id: arr[0],
          validationValue: {
            st_answer_text: allowChars.substr(0, allowChars.lastIndexOf('sep')),
            st_answer_score:
              key.indexOf('39') >= 0 ? questionData.st_answer_score : null
          }
        }
        // }
      }
      // for converting date to proper format
      //  else if (key == 30 || key == 31) {
      //   alert(questionData.validationDetails[42])
      //   questionData.validationDetails[key] = moment(questionData.validationDetails[key]).format(questionData.validationDetails[42])
      //   validationDetailsArray[i] = {
      //     in_question_validation_id: key,
      //     validationValue: {
      //       st_answer_text: questionData.validationDetails[key]
      //     }
      //   }
      //   i++
      // }
      else {
        // if (questionData['allowedValidations'].indexOf(parseInt(key)) > -1) {
        if (
          (key == 6 &&
            questionData.in_question_type_id == queTypeConfig.TYPE_LIST) ||
          key == 38
        ) {
          validationDetailsArray[i] = {
            in_question_validation_id: key,
            validationValue: {
              st_answer_text: questionData.validationDetails[key],
              st_answer_score: questionData.st_answer_score
            }
          }
          i++
        } else {
          if (key.includes('13') || key.includes('14')) {
            if (document.getElementById(key) || document.getElementById(key + ' others')) {
              validationDetailsArray[i] = {
                in_question_validation_id: key,
                validationValue: {
                  st_answer_text: questionData.validationDetails[key],
                  st_answer_score: key.includes('13')
                    ? document
                      .getElementById(key + ' others')
                      ? document
                        .getElementById(key + ' others')
                        .getAttribute('data-score-value')
                      : ''
                    : document
                      .getElementById(key)
                      .hasAttribute('data-score-value')
                      ? document
                        .getElementById(key)
                        .getAttribute('data-score-value')
                      : ''
                }
              }
              i++
            }
          } else if (key == 40) {
            validationDetailsArray[i] = {
              in_question_validation_id: key,
              validationValue: {
                st_answer_text: questionData.validationDetails[key],
                st_answer_score: questionData.st_answer_score
                  ? questionData.st_answer_score.split('\n')[0]
                  : null
              }
            }
            i++
          } else if (key == 41) {
            validationDetailsArray[i] = {
              in_question_validation_id: key,
              validationValue: {
                st_answer_text: questionData.validationDetails[key],
                st_answer_score: questionData.st_answer_score
                  ? questionData.st_answer_score.split('\n')[1]
                  : null
              }
            }
            i++
          } else if (key == 49) { // 49 = Address Question
            inAddress = 1;
            validationDetailsArray[i] = {
              in_question_validation_id: key,
              validationValue: {
                st_answer_text: questionData.validationDetails[key]
              }
            }
            i++
          } else {
            validationDetailsArray[i] = {
              in_question_validation_id: key,
              validationValue: {
                st_answer_text: questionData.validationDetails[key]
              }
            }
            i++
          }
        }

        // }
      }
    })

    if (allowCharsIndex > -1) {
      var allowedChars = validationDetailsArray[allowCharsIndex][
        'validationValue'
      ]['st_answer_text'].split('sep')
      var patt = '^['
      if (
        validationDetailsArray[allowCharsIndex]['in_question_validation_id'] ==
        26
      ) {
        patt += '0-9'
      }
      for (var j = 0; j < allowedChars.length; j++) {
        switch (allowedChars[j]) {
          // for allowed number characters in text input & telephone characters
          case 'A':
            patt += 'A-Za-z'
            break
          case '1':
            patt += '0-9'
            break
          case '\\':
            patt += '\\\\'
            break
          case ' ':
            patt += ' '
            break
          case '*':
            patt += '*'
            break
          case '()':
            patt += '\\(\\)'
            break
          case '[]':
            patt += '\\[\\]'
            break
          case '{}':
            patt += '\\{\\}'
            break
          case '?':
            patt += '\\?'
            break
          case '!':
            patt += '\\!'
            break
          case '%':
            patt += '%'
            break
          case '&':
            patt += '&'
            break
          case '@':
            patt += '@'
            break
          case '"':
            patt += '\\"\\“\\”'
            break
          case '.':
            patt += '\\.'
            break
          case ',':
            patt += '\\,'
            break
          case ':':
            patt += '\\:'
            break
          case '-':
            patt += '\\-'
            break
          case '=':
            patt += '='
            break
          case '+':
            patt += '\\+'
            break
          case '~':
            patt += '~'
            break
          case '#':
            patt += '\\#'
            break
          case '^':
            patt += '\\^'
            break
          case '/':
            patt += '\\/'
            break
          // for currency characters

          case '$':
            patt += '\\$'
            break
          case '£':
            patt += '\\£'
            break
          case '¥':
            patt += '\\¥'
            break
          case '₱':
            patt += '₱'
            break
          case 'R$':
            patt += '\\R$'
            break
          case 'Kč':
            patt += '\\Kč'
            break
          case 'kr':
            patt += '\\kr'
            break
          case '₩':
            patt += '\\₩'
            break
          case ' zł':
            patt += '\\ zł'
            break
          case 'R':
            patt += 'R'
            break
          case 'лв':
            patt += '\\лв'
            break
          case 'Bs':
            patt += '\\Bs'
            break
          case '₫':
            patt += '\\₫'
            break
          case '﷼':
            patt += '\\﷼'
            break
          case 'Z$':
            patt += 'Z$'
            break
          case 'Gs':
            patt += '\\Gs'
            break
          case 'ƒ':
            patt += '\\ƒ'
            break
          case 'RM':
            patt += '\\RM'
            break
          case 'J$':
            patt += '\\J$'
            break
        }
      }
      patt += ']+$'
      // var rx = new RegExp(patt, '')
      validationDetailsArray[allowCharsIndex]['validationValue'][
        'st_regex_value'
      ] = patt
    }
    if (questionData.in_question_type_id == queTypeConfig.TYPE_YES_NO) {
      validationDetailsArray[i] = {
        in_question_validation_id: queValidationConfig.VALIDATION_YES_NO,
        validationValue: {
          st_answer_text: 'Yes',
          st_answer_score: questionData.st_answer_score
            ? questionData.st_answer_score.split('\n')[0]
            : null
        }
      }
      i++
      validationDetailsArray[i] = {
        in_question_validation_id: queValidationConfig.VALIDATION_YES_NO,
        validationValue: {
          st_answer_text: 'No',
          st_answer_score: questionData.st_answer_score
            ? questionData.st_answer_score.split('\n')[1]
            : null
        }
      }
    } else if (
      questionData.in_question_type_id == queTypeConfig.TYPE_TRUE_FALSE
    ) {
      validationDetailsArray[i] = {
        in_question_validation_id: queValidationConfig.VALIDATION_TRUE_FALSE,
        validationValue: {
          st_answer_text: 'True',
          st_answer_score: questionData.st_answer_score
            ? questionData.st_answer_score.split('\n')[0]
            : null
        }
      }
      i++
      validationDetailsArray[i] = {
        in_question_validation_id: queValidationConfig.VALIDATION_TRUE_FALSE,
        validationValue: {
          st_answer_text: 'False',
          st_answer_score: questionData.st_answer_score
            ? questionData.st_answer_score.split('\n')[1]
            : null
        }
      }
    }

    // Validation Array Structure
    // validationDetailsArray[0] = {
    //   in_question_validation_id: 100,
    //   validationValue:
    //       {
    //         st_answer_text: 'Your views'
    //       }
    // }
    // validationDetailsArray[1] = {
    //   in_question_validation_id: 200,
    //   validationValue:
    //              {
    //                st_answer_text: 'Your views1'
    //              }
    // }
    //
    commit('setLoading', true)
    let hint = allowChars
    if (hint.indexOf('1') > -1) {
      hint =
        '1sep' +
        hint.slice(0, hint.indexOf('1')) +
        hint.slice(hint.indexOf('1') + 4)
    }
    if (hint.indexOf('A') > -1) {
      hint =
        'Asep' +
        hint.slice(0, hint.indexOf('A')) +
        hint.slice(hint.indexOf('A') + 4)
    }
    hint = hint.replace('A', 'A-Z')
    hint = hint.replace('1', '0-9')
    hint = hint.replace('sep ', 'sepspace')
    axios.defaults.headers.common['Authorization'] =
      questionData['sessionData']['jwt_token']
    let url =
      process.env.API_PATH +
      '/editSurveyQuestion/' +
      questionData['sessionData']['in_survey_Id']
    await axios
      .post(
        url,
        {
          lang: questionData['sessionData']['lang'],
          sessionData: questionData['sessionData'],
          request_id: questionData['sessionData']['requestId'],
          in_question_master_id: questionData['in_question_master_id'],
          in_question_type_id: questionData['in_question_type_id'],
          // 'in_question_order': questionData['in_question_order'],
          in_added_by: questionData['sessionData']['requestId'],
          st_question_title: questionData['st_question_title'],
          in_validation_details: validationDetailsArray,
          imageArray: questionData['imageArray'],
          in_audit: questionData["inAuditFlag"],
          deletedImageArray: questionData['deletedImageArray'],
          st_question_hint:
            allowCharsIndex > -1
              ? 'Allowed characters: ' + hint.substr(0, hint.lastIndexOf('sep'))
              : null,
          in_address: inAddress
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        response.validationDetails = questionData.validationDetails
        commit('setQuestionAll', response.data)
        commit('updateSurveyQuestions', response.data)
        commit('setSurveyQuestWithDetails', response.data)
      })
      .catch(error => {
        // let message = error.response.data.message || error.message
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },
  // delete question
  async deleteQuestion ({ commit, state }, questionData) {
    axios.defaults.headers.common['Authorization'] =
      questionData['sessionData']['jwt_token']
    let url = process.env.API_PATH + '/deleteSurveyQuestion'
    await axios
      .post(
        url,
        {
          lang: questionData['sessionData']['lang'],
          sessionData: questionData['sessionData'],
          request_id: questionData['sessionData']['requestId'],
          in_survey_Id: questionData['sessionData']['in_survey_Id'],
          in_question_master_id: questionData['in_question_master_id']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('deleteSurveyQuestions', questionData)
      })
      .catch(error => {
        // let message = error.response.data.message || error.message
      })
      .finally(() => {
        commit('deleteSurveyQuestionDetail', questionData)
        commit('setLoading', false)
      })
  },
  // activate/deactivate start/end screen
  activateDeactivateStartEndScreen ({ commit, state }, questionData) {
    axios.defaults.headers.common['Authorization'] =
      questionData['sessionData']['jwt_token']
    let url = process.env.API_PATH + '/setActivateDeactivateStartEndScreen'
    axios
      .post(
        url,
        {
          lang: questionData['sessionData']['lang'],
          sessionData: questionData['sessionData'],
          request_id: questionData['sessionData']['requestId'],
          in_survey_Id: questionData['sessionData']['in_survey_Id'],
          in_question_master_id: questionData['in_question_master_id'],
          is_active_inactive: questionData['is_active_inactive']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('setStartEndActivateStatus', response.data.data)
      })
      .catch(error => {
        // let message = error.response.data.message || error.message
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },
  // Add/Remove required Validation
  addAsRequiredSurveyQuestion ({ commit, state }, questionData) {
    axios.defaults.headers.common['Authorization'] =
      questionData['sessionData']['jwt_token']
    let url = process.env.API_PATH + '/addAsRequiredSurveyQuestion'
    axios
      .post(
        url,
        {
          lang: questionData['sessionData']['lang'],
          sessionData: questionData['sessionData'],
          request_id: questionData['sessionData']['requestId'],
          in_survey_Id: questionData['sessionData']['in_survey_Id'],
          in_question_master_id: questionData['in_question_master_id'],
          is_required_selected: questionData['is_required_selected'],
          in_added_by: questionData['sessionData']['requestId']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('setRequiredValidation', response.data)
      })
      .catch(error => {
        // let message = error.response.data.message || error.message
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },
  // get data for edit question
  async copyQuestionData ({ commit, state }, questionData) {
    if (questionData['sessionData'].in_survey_Id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] =
        questionData['sessionData']['jwt_token']
      let url = process.env.API_PATH + '/copySurveyQuestion'

      // lang:en
      // st_db_name:db_hispec_report_tapapp_child
      // st_db_host_name:192.168.1.217
      // in_survey_Id:172
      // in_question_type_id:9
      // in_question_master_id:1625
      await axios
        .post(
          url,
          {
            lang: questionData['sessionData']['lang'],
            request_id: questionData['sessionData']['requestId'],
            in_survey_Id: questionData['sessionData']['in_survey_Id'],
            in_question_type_id: questionData['in_question_type_id'],
            in_question_master_id: questionData['in_question_master_id']
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        .then(response => {
          if (response.data.flag) {
            response.data.data['in_control_id'] = questionData['in_control_id']
            response.data.data['st_control_name'] =
              questionData['st_control_name']
            response.data.data['st_class_name'] = questionData['st_class_name']
            commit('setCopyQuestionAll', response.data.data)
            commit('setSurveyQuestWithDetails', response.data.data)

            // To update surveyquestions accordingly if question is copied
            response.data.data.isCopied = 1
            commit('updateSurveyQuestions', response.data.data)
          } else {
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },
  // check for audit question
  async isSurveyQuestioninAudit ({ commit, state }, sessionData) {
    if (sessionData['in_survey_Id']) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
      let url = process.env.API_PATH + '/isSurveyQuestioninAudit'

      // lang:en
      // st_db_name:db_hispec_report_tapapp_child
      // st_db_host_name:192.168.1.217
      // in_survey_Id:172
      await axios
        .post(
          url,
          {
            lang: sessionData['lang'],
            request_id: sessionData['requestId'],
            in_survey_Id: sessionData['in_survey_Id'],
            in_survey_type: sessionData['in_survey_type'],
            in_audit: sessionData['in_audit']
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        .then(response => {
          if (response.data) {
            commit('setSurveyAudit', response.data)
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },

  // Delete survey details if no questions found in draft survey
  async removeEmptyQueSurvey({ commit, state }, sessionData) {
    if (sessionData['in_survey_Id']) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
      let url = process.env.API_PATH + '/removeEmptyQueSurvey'
      await axios
        .post(
          url,
          {
            lang: sessionData['lang'],
            request_id: sessionData['requestId'],
            in_survey_Id: sessionData['in_survey_Id']
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        .then(response => {
          if (response.data) {
            console.log(response.data);
          }
        })
        .catch(error => { })
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },

  // create skip logic rule
  async createSkipLogicRules ({ commit, state }, questionData) {
    if (
      questionData.in_question_type_id == queTypeConfig.TYPE_DISPLAY ||
      questionData.in_question_type_id == queTypeConfig.TYPE_IMAGE
    ) {
    }
    axios.defaults.headers.common['Authorization'] = questionData['jwt_token']
    let url = process.env.API_PATH + '/addSkipLogicRules'
    await axios
      .post(
        url,
        {
          lang: questionData['lang'],
          request_id: questionData['requestId'],
          in_survey_id: questionData['in_survey_Id'],
          in_question_master_id: questionData['in_question_master_id'],
          in_then_question_id: questionData['in_then_question_id'],
          in_then_question_number: questionData['in_then_question_number'],
          in_else_question_id: questionData['in_else_question_id'],
          in_else_question_number: questionData['in_else_question_number'],
          in_question_number: questionData['in_question_number'],
          st_skiplogic_condition: questionData['st_skiplogic_condition'],
          ans_noans_array: questionData['ans_noans_array'],
          rules_array: questionData['rules_array'],
          qtype_array: questionData['qtype_array'],
          in_skiplogic_master_id: questionData['in_skiplogic_master_id']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        if (response.data.flag === 0) {
        } else if (response.data.flag === 1) {
          commit('updateSkipLogicDetails', response.data.data)
        } else {
        }
      })
      .catch(e => {
        // this.$awn.alert(this.$t('message.catchapiError'))
        console.log(e)
      })
  },

  // get skip logic rules for all questions
  async getSkipLogicRules ({ commit, state }, questionData) {
    axios.defaults.headers.common['Authorization'] = questionData['jwt_token']
    let url = process.env.API_PATH + '/getSkipLogicRules'
    await axios
      .post(
        url,
        {
          lang: questionData['lang'],
          request_id: questionData['requestId'],
          in_survey_id: questionData['in_survey_Id']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        if (response.data.flag === 0) {
        } else if (response.data.flag === 1) {
          commit('setSkipLogicDetails', response.data)
        } else {
        }
      })
      .catch(e => {
        // this.$awn.alert(this.$t('message.catchapiError'))
        console.log(e)
      })
  },

  // delete skip logic rule
  async deleteSkipLogicRules ({ commit, state }, questionData) {
    axios.defaults.headers.common['Authorization'] = questionData['jwt_token']
    let url = process.env.API_PATH + '/deleteSkipLogicRules'
    await axios
      .post(
        url,
        {
          lang: questionData['lang'],
          request_id: questionData['requestId'],
          in_survey_id: questionData['in_survey_Id'],
          in_skiplogic_master_id: questionData['in_skiplogic_master_id']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        if (response.data.flag === 0) {
        } else if (response.data.flag === 1) {
          response.data.data['in_question_id'] = questionData['in_question_id']
          commit('updateSkipLogicDetails', response.data.data)
        } else {
        }
      })
      .catch(e => {
        // this.$awn.alert(this.$t('message.catchapiError'))
        console.log(e)
      })
  },
  // update min question number in skip logic
  updtSkipLogicStartQ ({ commit }, value) {
    commit('updtSkipLogicStartQ', value)
  },
  // update max question number in skip logic
  updtSkipLogicEndQ ({ commit }, value) {
    commit('updtSkipLogicEndQ', value)
  },
  // update question ids with skip logic
  updtSkipLogicQid ({ commit }, value) {
    commit('updtSkipLogicQid', value)
  },
  setQuery ({ commit }, value) {
    commit('setQuery', purify(value))
  },
  resetState ({ commit }) {
    commit('resetState')
  },
  setQuestionUpdated ({ commit }, value) {
    commit('setQuestionUpdated', value)
  },
  setIsSkipLogic ({ commit }, value) {
    commit('setIsSkipLogic', value)
  },
  setFullScreenMode ({ commit }, value) {
    commit('setFullScreenMode', value)
  },
  setExcelDataArray ({ commit }, value) {
    commit('setExcelDataArray', value)
  },
  setExcelQuestionMasterId({commit},value){
    commit('setExcelQuestionMasterId',value)
  },
  async addTagsDetails({commit, state}, questionData){
    axios.defaults.headers.common['Authorization'] = questionData['sessionData']['jwt_token'];
    let url = process.env.API_PATH + '/setTagsData'
    await axios
      .post(
        url,
        {
          lang: questionData['sessionData']['lang'],
          request_id: questionData['sessionData']['requestId'],
          in_survey_id: questionData['sessionData']['in_survey_Id'],
          in_question_master_id: state.ExcelQuestionMasterId,
          in_question_type_id: questionData['in_question_type_id'],
          excelDataArray: questionData['excelDataArray']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      ) 
      .then(response => {
          console.log("response of tags detail api",response);      
      })
      .catch(e => {
        // this.$awn.alert(this.$t('message.catchapiError'))
        console.log(e)
      })
  }
}
const mutations = {
  setsurveyQuestions (state, items) {
    state.surveyQuestions = items
    state.calledBefore = true
  },
  updateSurveyQuestions (state, items) {
    let temp = items
    temp.in_question_number = temp.in_question_order
    delete temp.flag
    delete temp.msg
    if (items.isCopied) {
      state.surveyQuestions.splice(temp.in_question_order, 0, temp)
    } else if (items.in_is_edited == 1) {
      state.surveyQuestions[temp.in_question_order - 1]['st_question_title'] =
        items.st_question_title
    } else {
      state.surveyQuestions.splice(temp.in_question_order - 1, 0, temp)
      for (
        let i = temp.in_question_order;
        i < state.surveyQuestions.length;
        i++
      ) {
        state.surveyQuestions[i]['in_question_number'] =
          state.surveyQuestions[i]['in_question_number'] + 1
      }
    }
  },
  deleteSurveyQuestions (state, items) {
    console.log(state.surveyQuestions)
    console.log(items.in_question_index)
    state.surveyQuestions.splice(items.in_question_index, 1)
    console.log(state.surveyQuestions)
    // for (
    //   let i = items.in_question_index;
    //   i < state.surveyQuestions.length;
    //   i++
    // ) {
    //   console.log(state.surveyQuestions[i]['in_question_number'])
    //   state.surveyQuestions[i]['in_question_number'] =
    //     state.surveyQuestions[i]['in_question_number'] - 1
    // }
  },
  setQuestionAll (state, items) {
    // For retrieving question data
    state.questionAll = items
  },
  setSurveyQuestionWithDetails (state, items) {
    state.surveyQuestionWithDetails = {}
    items.forEach((value, key) => {
      if (!state.surveyQuestionWithDetails[value.in_question_master_id]) {
        state.surveyQuestionWithDetails[value.in_question_master_id] = {}
      }
      // For multiple answers that are combined with \n
      if (
        value.in_validation_id === queValidationConfig.VALIDATION_TEXT ||
        value.in_validation_id === queValidationConfig.VALIDATION_YES_NO ||
        value.in_validation_id === queValidationConfig.VALIDATION_TRUE_FALSE ||
        value.in_validation_id ===
          queValidationConfig.VALIDATION_FIRST_CHOICE ||
        value.in_validation_id ===
          queValidationConfig.VALIDATION_SECOND_CHOICE ||
        value.in_validation_id ===
          queValidationConfig.VALIDATION_MULTIPLE_SINGLE_ANS ||
        value.in_validation_id ===
          queValidationConfig.VALIDATION_ALLOW_OTHER_ANS
      ) {
        if (
          state.surveyQuestionWithDetails[value.in_question_master_id][
            'qval_' + value.in_validation_id
          ]
        ) {
          state.surveyQuestionWithDetails[value.in_question_master_id][
            'qval_' + value.in_validation_id
          ]['st_answer_text'] += '\n' + value.st_answer_text

          if (
            value.in_validation_id === queValidationConfig.VALIDATION_TEXT ||
            value.in_validation_id === queValidationConfig.VALIDATION_YES_NO ||
            value.in_validation_id ===
              queValidationConfig.VALIDATION_TRUE_FALSE ||
            value.in_validation_id ===
              queValidationConfig.VALIDATION_FIRST_CHOICE ||
            value.in_validation_id ===
              queValidationConfig.VALIDATION_SECOND_CHOICE
          ) {
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]['st_answer_score'] += '\n' + value.st_answer_score

            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id] = {}
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id]['st_answer_text'] =
              value.st_answer_text
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id]['in_validation_id'] =
              value.in_validation_id
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id]['st_answer_score'] =
              value.st_answer_score
          }
        } else {
          state.surveyQuestionWithDetails[value.in_question_master_id][
            'qval_' + value.in_validation_id
          ] = value

          if (
            value.in_validation_id === queValidationConfig.VALIDATION_TEXT ||
            value.in_validation_id === queValidationConfig.VALIDATION_YES_NO ||
            value.in_validation_id ===
              queValidationConfig.VALIDATION_TRUE_FALSE ||
            value.in_validation_id ===
              queValidationConfig.VALIDATION_FIRST_CHOICE ||
            value.in_validation_id ===
              queValidationConfig.VALIDATION_ALLOW_OTHER_ANS
          ) {
            if (
              !state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ]
            ) {
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ] = {}
            }
            if (value.in_survey_question_answer_id) {
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id] = {}
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['st_answer_text'] =
                value.st_answer_text
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['in_validation_id'] =
                value.in_validation_id
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['st_answer_score'] =
                value.st_answer_score
            }

            value.in_validation_id ===
              queValidationConfig.VALIDATION_FIRST_CHOICE ||
            value.in_validation_id ===
              queValidationConfig.VALIDATION_ALLOW_OTHER_ANS
              ? ''
              : (state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ]['st_validation_name'] = 'Answers')
          } else if (
            value.in_validation_id ===
            queValidationConfig.VALIDATION_SECOND_CHOICE
          ) {
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id] = {}
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id]['st_answer_text'] =
              value.st_answer_text
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id]['in_validation_id'] =
              value.in_validation_id
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id]['st_answer_score'] =
              value.st_answer_score
          }
        }
      } else if (
        value.in_validation_id === queValidationConfig.VALIDATION_IMAGE
      ) {
        if (value.st_answer_text) {
          value.st_answer_text = JSON.parse(value.st_answer_text)
          value.s3_image_path = value.st_answer_text.s3ImagePath
          value.st_answer_text = value.st_answer_text.dataURL
        }
        if (
          value.in_question_type_id === queTypeConfig.TYPE_MULTIPLE_IMAGE &&
          value.st_answer_text
        ) {
          if (
            !state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]
          ) {
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ] = value
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]['st_answer_details'] = []
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]['st_answer_label_details'] = []
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]['st_answer_path_details'] = []
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]['st_answer_details'].push(value.st_answer_text)
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]['st_answer_label_details'].push(value.st_answer_label)
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]['st_answer_path_details'].push(value.s3_image_path)
            if (
              !state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ]
            ) {
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ] = {}
            }
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id] = {}
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id]['st_answer_text'] =
              value.st_answer_text
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id]['in_validation_id'] =
              value.in_validation_id
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id]['st_answer_score'] =
              value.st_answer_score
          } else {
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ].st_answer_details.push(value.st_answer_text)
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ].st_answer_label_details.push(value.st_answer_label)
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]['st_answer_path_details'].push(value.s3_image_path)

            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]['st_answer_score'] += '\n' + value.st_answer_score

            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id] = {}
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id]['st_answer_text'] =
              value.st_answer_text
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id]['in_validation_id'] =
              value.in_validation_id
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'score_data'
            ][value.in_survey_question_answer_id]['st_answer_score'] =
              value.st_answer_score
          }
        } else {
          state.surveyQuestionWithDetails[value.in_question_master_id][
            'qval_' + value.in_validation_id
          ]
            ? (state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]['st_answer_text'] += '\n' + value.st_answer_text)
            : (state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ] = value)
          state.surveyQuestionWithDetails[value.in_question_master_id][
            'qval_' + value.in_validation_id
          ]['st_validation_name'] = 'Answers'
        }
      } else {
        if (
          state.surveyQuestionWithDetails[value.in_question_master_id][
            value.in_validation_id
          ] &&
          value.st_answer_text
        ) {
          if (
            (value.in_validation_id ==
              queValidationConfig.VALIDATION_SINGLE_LINE &&
              value.in_question_type_id == queTypeConfig.TYPE_LIST) ||
            value.in_validation_id ==
              queValidationConfig.VALIDATION_STAR_RATING ||
            value.in_validation_id ==
              queValidationConfig.VALIDATION_FACE_RATING ||
            value.in_validation_id == queValidationConfig.VALIDATION_SUBTITLE ||
            value.in_validation_id == queValidationConfig.VALIDATION_TIMEOUT ||
            value.in_validation_id == queValidationConfig.VALIDATION_BUTTON ||
            value.in_validation_id ==
              queValidationConfig.VALIDATION_TIMEOUT_IN_SEC
          ) {
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ] = value
          } else if (
            value.in_validation_id == queValidationConfig.VALIDATION_BUTTON_TEXT
          ) {
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'zqval_' + value.in_validation_id
            ] = value
          } else {
            state.surveyQuestionWithDetails[value.in_question_master_id][
              value.in_validation_id
            ] = value
          }
        } else {
          if (
            !state.surveyQuestionWithDetails[value.in_question_master_id][
              value.in_validation_id
            ]
          ) {
            if (
              (value.in_validation_id ==
                queValidationConfig.VALIDATION_SINGLE_LINE &&
                value.in_question_type_id == queTypeConfig.TYPE_LIST) ||
              value.in_validation_id ==
                queValidationConfig.VALIDATION_STAR_RATING ||
              value.in_validation_id ==
                queValidationConfig.VALIDATION_FACE_RATING ||
              value.in_validation_id ==
                queValidationConfig.VALIDATION_SUBTITLE ||
              value.in_validation_id ==
                queValidationConfig.VALIDATION_TIMEOUT ||
              value.in_validation_id == queValidationConfig.VALIDATION_BUTTON ||
              value.in_validation_id ==
                queValidationConfig.VALIDATION_TIMEOUT_IN_SEC
            ) {
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ] = value
            } else if (
              value.in_validation_id ==
              queValidationConfig.VALIDATION_BUTTON_TEXT
            ) {
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'zqval_' + value.in_validation_id
              ] = value
            } else {
              state.surveyQuestionWithDetails[value.in_question_master_id][
                value.in_validation_id
              ] = value
            }
          }
        }
      }
    })
  },
  setsurveyStartEndQuestions (state, items) {
    let tempData = {}
    if (items[0]) {
      items[0]['in_question_type_id'] === queTypeConfig.TYPE_START_SCREEN_TEXT
        ? (tempData['start'] = items[0])
        : (tempData['end'] = items[0])
    }
    if (items[1]) {
      items[1]['in_question_type_id'] === queTypeConfig.TYPE_START_SCREEN_TEXT
        ? (tempData['start'] = items[1])
        : (tempData['end'] = items[1])
    }
    state.surveyStartEndQuestions = Object.assign({}, tempData)
    tempData = {}
  },
  setStartEndActivateStatus (state, items) {
    let tempData = state.surveyStartEndQuestions
    if (tempData.start.in_question_master_id === items.in_question_master_id) {
      tempData.start.in_status = items.in_status
    } else {
      tempData.end.in_status = items.in_status
    }
    state.surveyStartEndQuestions = Object.assign({}, tempData)
  },
  setsurveyStartEndQuestionsAfterCreate (state, items) {
    let tempData = {}
    if (items.in_question_type_id === queTypeConfig.TYPE_START_SCREEN_TEXT) {
      tempData['start'] = items
      state.surveyStartEndQuestions = Object.assign({}, tempData)
    } else if (
      items.in_question_type_id === queTypeConfig.TYPE_END_SCREEN_TEXT
    ) {
      tempData['end'] = items
      state.surveyStartEndQuestions = Object.assign({}, tempData)
    }
    tempData = {}
  },
  setCopyQuestionAll (state, items) {
    state.copyQuestionAll = items
  },
  setQuestionId (state, items) {
    let tempVar = {}

    tempVar.in_question_master_id = items.in_question_master_id
    tempVar.st_question_title = items.st_question_title
    tempVar.in_question_type_id = items.in_question_type_id
    tempVar.in_question_order = items.in_question_order
    tempVar.question_validation_details = items.question_validation_details
    tempVar.is_created = 1
    tempVar.in_is_edited = items.in_is_edited
    state.questionAll = tempVar
    if (items['in_question_type_id'] === queTypeConfig.TYPE_START_SCREEN_TEXT) {
      items['question_type_details'] = {}
      items['question_type_details']['in_control_id'] =
        queControlConfig.CONTROL_START_SCREEN
      state.surveyStartEndQuestions['start'] = items
    }
    if (items['in_question_type_id'] === queTypeConfig.TYPE_END_SCREEN_TEXT) {
      items['question_type_details'] = {}
      items['question_type_details']['in_control_id'] =
        queControlConfig.CONTROL_END_SCREEN
      state.surveyStartEndQuestions['end'] = items
    }
  },
  setRequiredValidation (state, items) {
    // If selected question is same on which required is clicked and is currently displayed
    if (
      state.questionAll.in_question_master_id == items.in_question_master_id
    ) {
      var valIndex = -1
      if (state.questionAll.question_validation_details) {
        valIndex = state.questionAll.question_validation_details.findIndex(
          obj => obj['in_question_validation_id'] === 1
        )
      }
      if (items.flag === 1) {
        if (valIndex >= 0) {
          items = state.questionAll
          if (
            !items.question_validation_details[valIndex][
              'question_answer_details'
            ]
          ) {
            items.question_validation_details[valIndex][
              'question_answer_details'
            ] = []
          }
          if (
            items.question_validation_details[valIndex][
              'question_answer_details'
            ][0]
          ) {
            items.question_validation_details[valIndex][
              'question_answer_details'
            ][0]['st_answer_text'] = 1
          } else {
            items.question_validation_details[valIndex][
              'question_answer_details'
            ][0] = {}
            items.question_validation_details[valIndex][
              'question_answer_details'
            ][0]['st_answer_text'] = 1
          }
        } else {
          var tempObj = {}
          tempObj['in_question_validation_id'] = 1
          tempObj['question_answer_details'] = []
          var tempArr = {}
          tempArr['st_answer_text'] = 1
          tempObj['question_answer_details'].push(tempArr)

          items = state.questionAll
          if (items.question_validation_details) {
            items.question_validation_details.push(tempObj)
          } else {
            items['question_validation_details'] = []
            items.question_validation_details.push(tempObj)
          }
        }
      } else {
        if (valIndex >= 0) {
          items = state.questionAll
          if (
            !items.question_validation_details[valIndex][
              'question_answer_details'
            ]
          ) {
            items.question_validation_details[valIndex][
              'question_answer_details'
            ] = []
            items.question_validation_details[valIndex][
              'question_answer_details'
            ][0] = {}
            items.question_validation_details[valIndex][
              'question_answer_details'
            ][0]['st_answer_text'] = 0
          } else if (
            !items.question_validation_details[valIndex][
              'question_answer_details'
            ][0]
          ) {
            items.question_validation_details[valIndex][
              'question_answer_details'
            ][0] = {}
            items.question_validation_details[valIndex][
              'question_answer_details'
            ][0]['st_answer_text'] = 0
          } else {
            items.question_validation_details[valIndex][
              'question_answer_details'
            ][0]['st_answer_text'] = 0
          }
        } else {
          items = state.questionAll
          items.question_validation_details = []
          items.question_validation_details[0] = {}
          items.question_validation_details[0]['in_question_validation_id'] = 1
          items.question_validation_details[0]['question_answer_details'] = []
          items.question_validation_details[0][
            'question_answer_details'
          ][0] = {}
          items.question_validation_details[0]['question_answer_details'][0][
            'st_answer_text'
          ] = 0
        }
      }
      state.questionAll = []
      state.questionAll = items
    }
  },
  setLoading (state, loading) {
    state.loading = loading
  },
  setLoadingAllSurveyDetails (state, loading) {
    state.loadingAllSurveyDetails = loading
  },
  setQuestionUpdated (state, questionUpdated) {
    state.questionUpdated = questionUpdated
  },
  updtSkipLogicStartQ (state, skipMinQ) {
    state.skipLogicStartQ = skipMinQ
  },
  updtSkipLogicEndQ (state, skipMaxQ) {
    state.skipLogicEndQ = skipMaxQ
  },
  updtSkipLogicQid (state, skipQids) {
    state.skipLogicQids = skipQids
  },
  setQuery (state, query) {
    state.query = query
  },
  resetState (state) {
    state = Object.assign(state, initialState())
  },
  setsurveyQuestionsOrder (state, items) {
    items.forEach((value, key) => {
      const index = state.surveyQuestions.findIndex(
        val => val.in_question_master_id === value || val.dbQueId === value
      )
      state.surveyQuestions[index].in_question_number = key + 1
      state.surveyQuestions[index].in_question_order = key + 1
    })
    state.surveyQuestions.sort(function (a, b) {
      return a.in_question_order > b.in_question_order
        ? 1
        : b.in_question_order > a.in_question_order
          ? -1
          : 0
    })
  },
  setSurveyQuestWithDetails (state, items) {
    // Common mutation For edit question and updating for expand/collapse
    if (items.expandValidationDetails) {
      let tempVar = {}
      tempVar = state.surveyQuestionWithDetails
      if (tempVar[items.in_question_master_id]) {
        delete tempVar[items.in_question_master_id]
      }
      tempVar[items.in_question_master_id] = {}

      items.expandValidationDetails.forEach((value, key) => {
        if (
          value.in_validation_id === queValidationConfig.VALIDATION_TEXT ||
          value.in_validation_id === queValidationConfig.VALIDATION_YES_NO ||
          value.in_validation_id ===
            queValidationConfig.VALIDATION_TRUE_FALSE ||
          value.in_validation_id ===
            queValidationConfig.VALIDATION_FIRST_CHOICE ||
          value.in_validation_id ===
            queValidationConfig.VALIDATION_SECOND_CHOICE ||
          value.in_validation_id ===
            queValidationConfig.VALIDATION_MULTIPLE_SINGLE_ANS ||
          value.in_validation_id ===
            queValidationConfig.VALIDATION_ALLOW_OTHER_ANS
        ) {
          if (
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]
          ) {
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]['st_answer_text'] += '\n' + value.st_answer_text

            if (
              value.in_validation_id === queValidationConfig.VALIDATION_TEXT ||
              value.in_validation_id ===
                queValidationConfig.VALIDATION_YES_NO ||
              value.in_validation_id ===
                queValidationConfig.VALIDATION_TRUE_FALSE ||
              value.in_validation_id ===
                queValidationConfig.VALIDATION_FIRST_CHOICE ||
              value.in_validation_id ===
                queValidationConfig.VALIDATION_SECOND_CHOICE
            ) {
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ]['st_answer_score'] += '\n' + value.st_answer_score

              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id] = {}
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['st_answer_text'] =
                value.st_answer_text
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['in_validation_id'] =
                value.in_validation_id
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['st_answer_score'] =
                value.st_answer_score
            }
          } else {
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ] = value

            if (
              value.in_validation_id === queValidationConfig.VALIDATION_TEXT ||
              value.in_validation_id ===
                queValidationConfig.VALIDATION_YES_NO ||
              value.in_validation_id ===
                queValidationConfig.VALIDATION_TRUE_FALSE ||
              value.in_validation_id ===
                queValidationConfig.VALIDATION_FIRST_CHOICE ||
              value.in_validation_id ===
                queValidationConfig.VALIDATION_ALLOW_OTHER_ANS
            ) {
              if (
                !state.surveyQuestionWithDetails[value.in_question_master_id][
                  'score_data'
                ]
              ) {
                state.surveyQuestionWithDetails[value.in_question_master_id][
                  'score_data'
                ] = {}
              }
              if (value.in_survey_question_answer_id) {
                state.surveyQuestionWithDetails[value.in_question_master_id][
                  'score_data'
                ][value.in_survey_question_answer_id] = {}
                state.surveyQuestionWithDetails[value.in_question_master_id][
                  'score_data'
                ][value.in_survey_question_answer_id]['st_answer_text'] =
                  value.st_answer_text
                state.surveyQuestionWithDetails[value.in_question_master_id][
                  'score_data'
                ][value.in_survey_question_answer_id]['in_validation_id'] =
                  value.in_validation_id
                state.surveyQuestionWithDetails[value.in_question_master_id][
                  'score_data'
                ][value.in_survey_question_answer_id]['st_answer_score'] =
                  value.st_answer_score
              }
              value.in_validation_id ===
                queValidationConfig.VALIDATION_FIRST_CHOICE ||
              value.in_validation_id ===
                queValidationConfig.VALIDATION_ALLOW_OTHER_ANS
                ? ''
                : (state.surveyQuestionWithDetails[value.in_question_master_id][
                  'qval_' + value.in_validation_id
                ]['st_validation_name'] = 'Answers')
            } else if (
              value.in_validation_id ===
              queValidationConfig.VALIDATION_SECOND_CHOICE
            ) {
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id] = {}
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['st_answer_text'] =
                value.st_answer_text
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['in_validation_id'] =
                value.in_validation_id
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['st_answer_score'] =
                value.st_answer_score
            }
          }
        } else if (
          value.in_validation_id === queValidationConfig.VALIDATION_IMAGE
        ) {
          if (value.st_answer_text) {
            value.st_answer_text = JSON.parse(value.st_answer_text)
            value.s3_image_path = value.st_answer_text.s3ImagePath
            value.st_answer_text = value.st_answer_text.dataURL
          }
          if (
            value.in_question_type_id === queTypeConfig.TYPE_MULTIPLE_IMAGE &&
            value.st_answer_text
          ) {
            if (
              !state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ]
            ) {
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ] = value
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ]['st_answer_details'] = []
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ]['st_answer_label_details'] = []
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ]['st_answer_path_details'] = []
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ]['st_answer_details'].push(value.st_answer_text)
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ]['st_answer_label_details'].push(value.st_answer_label)
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ]['st_answer_path_details'].push(value.s3_image_path)

              if (
                !state.surveyQuestionWithDetails[value.in_question_master_id][
                  'score_data'
                ]
              ) {
                state.surveyQuestionWithDetails[value.in_question_master_id][
                  'score_data'
                ] = {}
              }
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id] = {}
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['st_answer_text'] =
                value.st_answer_text
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['in_validation_id'] =
                value.in_validation_id
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['st_answer_score'] =
                value.st_answer_score
            } else {
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ].st_answer_details.push(value.st_answer_text)
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ].st_answer_label_details.push(value.st_answer_label)
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ]['st_answer_path_details'].push(value.s3_image_path)

              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ]['st_answer_score'] += '\n' + value.st_answer_score

              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id] = {}
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['st_answer_text'] =
                value.st_answer_text
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['in_validation_id'] =
                value.in_validation_id
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'score_data'
              ][value.in_survey_question_answer_id]['st_answer_score'] =
                value.st_answer_score
            }
          } else {
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]
              ? (state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ]['st_answer_text'] += '\n' + value.st_answer_text)
              : (state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ] = value)
            state.surveyQuestionWithDetails[value.in_question_master_id][
              'qval_' + value.in_validation_id
            ]['st_validation_name'] = 'Answers'
          }
        } else {
          if (
            state.surveyQuestionWithDetails[value.in_question_master_id][
              value.in_validation_id
            ] &&
            value.st_answer_text
          ) {
            if (
              (value.in_validation_id ==
                queValidationConfig.VALIDATION_SINGLE_LINE &&
                value.in_question_type_id == queTypeConfig.TYPE_LIST) ||
              value.in_validation_id ==
                queValidationConfig.VALIDATION_STAR_RATING ||
              value.in_validation_id ==
                queValidationConfig.VALIDATION_FACE_RATING ||
              value.in_validation_id ==
                queValidationConfig.VALIDATION_SUBTITLE ||
              value.in_validation_id ==
                queValidationConfig.VALIDATION_TIMEOUT ||
              value.in_validation_id == queValidationConfig.VALIDATION_BUTTON ||
              value.in_validation_id ==
                queValidationConfig.VALIDATION_TIMEOUT_IN_SEC
            ) {
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'qval_' + value.in_validation_id
              ] = value
            } else if (
              value.in_validation_id ==
              queValidationConfig.VALIDATION_BUTTON_TEXT
            ) {
              state.surveyQuestionWithDetails[value.in_question_master_id][
                'zqval_' + value.in_validation_id
              ] = value
            } else {
              state.surveyQuestionWithDetails[value.in_question_master_id][
                value.in_validation_id
              ] = value
            }
          } else {
            if (
              !state.surveyQuestionWithDetails[value.in_question_master_id][
                value.in_validation_id
              ]
            ) {
              if (
                (value.in_validation_id ==
                  queValidationConfig.VALIDATION_SINGLE_LINE &&
                  value.in_question_type_id == queTypeConfig.TYPE_LIST) ||
                value.in_validation_id ==
                  queValidationConfig.VALIDATION_STAR_RATING ||
                value.in_validation_id ==
                  queValidationConfig.VALIDATION_FACE_RATING ||
                value.in_validation_id ==
                  queValidationConfig.VALIDATION_SUBTITLE ||
                value.in_validation_id ==
                  queValidationConfig.VALIDATION_TIMEOUT ||
                value.in_validation_id ==
                  queValidationConfig.VALIDATION_BUTTON ||
                value.in_validation_id ==
                  queValidationConfig.VALIDATION_TIMEOUT_IN_SEC
              ) {
                state.surveyQuestionWithDetails[value.in_question_master_id][
                  'qval_' + value.in_validation_id
                ] = value
              } else if (
                value.in_validation_id ==
                queValidationConfig.VALIDATION_BUTTON_TEXT
              ) {
                state.surveyQuestionWithDetails[value.in_question_master_id][
                  'zqval_' + value.in_validation_id
                ] = value
              } else {
                state.surveyQuestionWithDetails[value.in_question_master_id][
                  value.in_validation_id
                ] = value
              }
            }
          }
        }
      })
      state.surveyQuestionWithDetails = Object.assign({}, tempVar)
      tempVar = {}
    }
  },
  setScoreInExpandData (state, items) {
    if (items.in_question_master_id) {
      if (
        items.in_question_type_id == queTypeConfig.TYPE_LIST ||
        items.in_question_type_id == queTypeConfig.TYPE_SATISFACTION ||
        items.in_question_type_id == queTypeConfig.TYPE_STAR
      ) {
        let tempVar = state.surveyQuestionWithDetails
        items.in_question_type_id == queTypeConfig.TYPE_LIST
          ? ((tempVar[items.in_question_master_id]['qval_6'][
            'st_answer_score'
          ] = items.st_answer_score),
          (tempVar[items.in_question_master_id]['qval_13'][
            'st_answer_score'
          ] = items.othersData.st_answer_score))
          : items.in_question_type_id == queTypeConfig.TYPE_STAR
            ? (tempVar[items.in_question_master_id]['qval_38'][
              'st_answer_score'
            ] = items.st_answer_score)
            : (tempVar[items.in_question_master_id]['qval_39'][
              'st_answer_score'
            ] = items.st_answer_score)
        state.surveyQuestionWithDetails = Object.assign({}, tempVar)
      } else if (
        items.in_question_type_id == queTypeConfig.TYPE_YES_NO ||
        items.in_question_type_id == queTypeConfig.TYPE_MULTIPLE_TEXT ||
        items.in_question_type_id == queTypeConfig.TYPE_TRUE_FALSE ||
        items.in_question_type_id == queTypeConfig.TYPE_OTHER ||
        items.in_question_type_id == queTypeConfig.TYPE_MULTIPLE_IMAGE
      ) {
        let tempVar = state.surveyQuestionWithDetails
        tempVar[items.in_question_master_id]['score_data'] = items.score_data

        // For updating score values in expand collapse for others option.
        Object.keys(items.score_data).forEach(key => {
          if (items.score_data[key]['in_validation_id'] == 13) {
            tempVar[items.in_question_master_id]['qval_13']['st_answer_score'] =
              items.score_data[key]['st_answer_score']
          }
        })

        switch (items.in_question_type_id) {
          // for allowed number characters in text input & telephone characters
          case 5:
            tempVar[items.in_question_master_id]['qval_14']['st_answer_score'] =
              items.scoreValues
            break
          case 13:
            tempVar[items.in_question_master_id]['qval_15']['st_answer_score'] =
              items.scoreValues
            break
          case 4:
            tempVar[items.in_question_master_id]['qval_16']['st_answer_score'] =
              items.scoreValues
            break
          case 11:
            tempVar[items.in_question_master_id]['qval_17']['st_answer_score'] =
              items.scoreValues
            break
          case 12:
            tempVar[items.in_question_master_id]['qval_40'][
              'st_answer_score'
            ] = items.scoreValues.split('\n')[0]
            tempVar[items.in_question_master_id]['qval_41'][
              'st_answer_score'
            ] = items.scoreValues.split('\n')[1]
            break
        }

        // items.in_question_type_id == 5
        //   ? (tempVar[items.in_question_master_id]['qval_14'][
        //     'st_answer_score'
        //   ] = items.scoreValues)
        //   : (items.in_question_type_id == 13
        //     ? (tempVar[items.in_question_master_id]['qval_15'][
        //       'st_answer_score'
        //     ] = items.scoreValues)
        //     : (items.in_question_type_id == 4
        //       ? (tempVar[items.in_question_master_id]['qval_16'][
        //         'st_answer_score'
        //       ] = items.scoreValues)
        //       : (items.in_question_type_id == 11
        //         ? (tempVar[items.in_question_master_id]['qval_17'][
        //           'st_answer_score'
        //         ] = items.scoreValues)
        //         : (tempVar[items.in_question_master_id]['qval_18'][
        //           'st_answer_score'
        //         ] = items.scoreValues))))
        state.surveyQuestionWithDetails = Object.assign({}, tempVar)
      }
    }
  },
  setSkipLogicDetails (state, items) {
    state.skipLogicStartQ = items.minmaxqnos[0]['minqno']
    state.skipLogicEndQ = items.minmaxqnos[0]['maxqno']
    state.skipLogicEndScreen = items.minmaxqnos[0]['endScreen']

    items.data.forEach((value, key) => {
      state.skipLogicDetails[value['in_question_master_id']] = []
      if (value['skip_logic_master_details'].length > 0) {
        state.skipLogicDetails[value['in_question_master_id']] = []
        value['skip_logic_master_details'].forEach((skiprule, skipkey) => {
          state.skipLogicDetails[value['in_question_master_id']].push({
            in_skiplogic_master_id: skiprule['in_skiplogic_master_id'],
            in_then_question_id: skiprule['in_then_question_id'],
            in_then_question_number: skiprule['in_then_question_number'],
            in_else_question_id: skiprule['in_else_question_id'],
            in_else_question_number: skiprule['in_else_question_number'],
            in_question_number: skiprule['in_question_number'],
            rules_array: []
          })
          if (skiprule.skip_logic_rule && skiprule.skip_logic_rule.length > 0) {
            state.skipLogicDetails[value['in_question_master_id']][
              state.skipLogicDetails[value['in_question_master_id']].length - 1
            ].st_skiplogic_condition = []
            state.skipLogicDetails[value['in_question_master_id']][
              state.skipLogicDetails[value['in_question_master_id']].length - 1
            ].st_skiplogic_ansnoans = []
            skiprule.skip_logic_rule.forEach((val, k) => {
              state.skipLogicDetails[value['in_question_master_id']][
                state.skipLogicDetails[value['in_question_master_id']].length -
                  1
              ].rules_array[k] = []
              // Push condition between rules in an array
              state.skipLogicDetails[value['in_question_master_id']][
                state.skipLogicDetails[value['in_question_master_id']].length -
                  1
              ].st_skiplogic_condition.push(val.st_skiplogic_condition)

              // Push answered not answered of rules in an array
              state.skipLogicDetails[value['in_question_master_id']][
                state.skipLogicDetails[value['in_question_master_id']].length -
                  1
              ].st_skiplogic_ansnoans.push(val.st_is_answer)

              state.skipLogicDetails[value['in_question_master_id']][
                state.skipLogicDetails[value['in_question_master_id']].length -
                  1
              ].in_question_type_id = val.in_question_type_id

              val.skip_logic_rule_details.forEach((rule, rk) => {
                let ruleObj = {}
                ruleObj.st_answer_value = rule.st_answer_value
                ruleObj.in_question_master_id = rule.in_question_master_id
                ruleObj.st_logical_condition = rule.st_logical_condition
                ruleObj.st_rule_type = rule.st_rule_type
                state.skipLogicDetails[value['in_question_master_id']][
                  state.skipLogicDetails[value['in_question_master_id']]
                    .length - 1
                ].rules_array[k].push(ruleObj)
                // Push qid's of questions on which once skip logic rules are added into the array
                if (
                  val.st_is_answer === 'NOTANSWERED' ||
                  (rk === 0 &&
                    val.st_is_answer === 'ANSWERED' &&
                    rule.st_answer_value === 'NA')
                ) {
                  state.ruleCreatedIds.push(rule.in_question_master_id)
                }
              })
            })
          }
        })
      }
    })
    state.skipLogicRetrieved = true
  },
  updateSkipLogicDetails (state, items) {
    let tempVar = {}
    tempVar = state.skipLogicDetails

    let ruleArrayIndex = ''
    if (items.is_edited) {
      if (
        Object.keys(tempVar[items.skip_master.in_parent_question_id]).length ==
        0
      ) {
        tempVar[items.skip_master.in_parent_question_id] = []
      }
      ruleArrayIndex = tempVar[
        items.skip_master.in_parent_question_id
      ].findIndex(
        item =>
          item.in_skiplogic_master_id ===
          items.skip_master.in_skiplogic_master_id
      )

      tempVar[items.skip_master.in_parent_question_id][ruleArrayIndex] = {}
      tempVar[items.skip_master.in_parent_question_id][ruleArrayIndex] = {
        in_skiplogic_master_id: items.skip_master.in_skiplogic_master_id,
        in_then_question_id: items.skip_master.in_then_question_id,
        in_then_question_number: items.skip_master.in_then_question_number,
        in_else_question_id: items.skip_master.in_else_question_id,
        in_else_question_number: items.skip_master.in_else_question_number,
        in_question_number: items.skip_master.in_question_number,
        rules_array: []
      }

      // let allRules = tempVar[items.skip_master.in_parent_question_id]

      // tempVar[items.skip_master.in_parent_question_id] = allRules.filter(
      //   item =>
      //     item.in_skiplogic_master_id !==
      //     items.skip_master.in_skiplogic_master_id
      // )
      state.skipLogicEndQ = -4
    } else if (items.is_deleted) {
      delete tempVar[items.in_skiplogic_master_id]
      let tempRules = tempVar[items.in_question_id]
      tempVar[items.in_question_id] = tempRules.filter(x => {
        if (x.in_skiplogic_master_id !== items.in_skiplogic_master_id) {
          return true
        } else {
          let index = state.ruleCreatedIds.indexOf(
            x.rules_array[0][0].in_question_master_id
          )
          if (index > -1) {
            state.ruleCreatedIds.splice(index, 1)
          }
          return false
        }
      })
      state.skipLogicEndQ = -4
    } else {
      const parentQuestionId = items.skip_master.in_parent_question_id;
      if (!tempVar[parentQuestionId] || Object.keys(tempVar[parentQuestionId]).length == 0) {
        tempVar[parentQuestionId] = []
      }
      tempVar[items.skip_master.in_parent_question_id].push({
        in_skiplogic_master_id: items.skip_master.in_skiplogic_master_id,
        in_then_question_id: items.skip_master.in_then_question_id,
        in_then_question_number: items.skip_master.in_then_question_number,
        in_else_question_id: items.skip_master.in_else_question_id,
        in_else_question_number: items.skip_master.in_else_question_number,
        in_question_number: items.skip_master.in_question_number,
        rules_array: []
      })
      ruleArrayIndex =
        tempVar[items.skip_master.in_parent_question_id].length - 1
      if (state.skipLogicEndQ < items.skip_master.in_then_question_number) {
        state.skipLogicEndQ = items.skip_master.in_then_question_number
      }
      if (state.skipLogicEndQ < items.skip_master.in_else_question_number) {
        state.skipLogicEndQ = items.skip_master.in_else_question_number
      }
    }
    // update skip logic data

    if (items.rule_master_details && items.rule_master_details.length > 0) {
      tempVar[items.skip_master.in_parent_question_id][
        ruleArrayIndex
      ].st_skiplogic_condition = []
      tempVar[items.skip_master.in_parent_question_id][
        ruleArrayIndex
      ].st_skiplogic_ansnoans = []

      items.rule_master_details.forEach((val, k) => {
        tempVar[items.skip_master.in_parent_question_id][
          ruleArrayIndex
        ].rules_array[k] = []
        tempVar[items.skip_master.in_parent_question_id][
          ruleArrayIndex
        ].st_skiplogic_condition.push(val.st_skiplogic_condition)

        tempVar[items.skip_master.in_parent_question_id][
          ruleArrayIndex
        ].st_skiplogic_ansnoans.push(val.st_is_answer)

        tempVar[items.skip_master.in_parent_question_id][
          ruleArrayIndex
        ].in_question_type_id = val.in_question_type_id

        let isEdited = 0
        val.rule_details.forEach((rule, rk) => {
          let ruleObj = {}
          ruleObj.st_answer_value = rule.st_answer_value
          ruleObj.in_question_master_id = rule.in_question_master_id
          ruleObj.st_logical_condition = rule.st_logical_condition
          ruleObj.st_rule_type = rule.st_rule_type
          tempVar[items.skip_master.in_parent_question_id][
            ruleArrayIndex
          ].rules_array[k].push(ruleObj)
          // Push qid's of questions on which once skip logic rules are added into the array
          if (
            val.st_is_answer === 'NOTANSWERED' ||
            (rk === 0 &&
              val.st_is_answer === 'ANSWERED' &&
              rule.st_answer_value === 'NA')
          ) {
            isEdited = 1
            if (state.ruleCreatedIds.indexOf(rule.in_question_master_id) === -1) {
              state.ruleCreatedIds.push(rule.in_question_master_id)
            }
          }
          if (isEdited === 0) {
            let index = state.ruleCreatedIds.indexOf(
              rule.in_question_master_id
            )
            if (index > -1) {
              state.ruleCreatedIds.splice(index, 1)
            }
          }
        })
      })
    }
    // Update skipLogicEndScreen variable if end screen is added/deleted from skip logic.
    var isEndScreenQ
    Object.keys(tempVar).every((element, index) => {
      isEndScreenQ = tempVar[element].findIndex(p => (p.in_then_question_number == -2 || p.in_then_question_number == -99 || p.in_else_question_number == -2 || p.in_else_question_number == -99))
      if (isEndScreenQ > -1) { return false } else { return true }
    })
    if (isEndScreenQ > -1) {
      state.skipLogicEndScreen = true
    } else {
      state.skipLogicEndScreen = false
    }

    state.skipLogicDetails = Object.assign({}, tempVar)
    tempVar = {}
    state.skipLogicKey = state.skipLogicKey + 1
  },
  setSurveyQuestionAnswerWithScore (state, items) {
    state.SurveyQuestionAnswerWithScore = items
  },
  setSurveyAudit (state, items) {
    state.surveyAudit = items.flag
  },
  deleteSurveyQuestionDetail (state, items) {
    delete state.surveyQuestionWithDetails[items.in_question_master_id]
  },
  setIsSkipLogic (state, items) {
    state.isSkipLogic = items.skipLogic
    state.currentQno = items.qno
  },
  setFullScreenMode (state, items) {
    state.isFullScreen = items
  },
  setExcelDataArray (state, items) {
    state.excelDataArray = items 
    console.log("excelDataArray", state.excelDataArray);
  },
  setExcelQuestionMasterId (state,items){
    state.ExcelQuestionMasterId = items
    console.log("ExcelQuestionMasterId",state.ExcelQuestionMasterId);
  },
  setAnswersWithTagsDetail (state, items) {
    state.AnswersWithTagsDetail = '';
    state.AnswersWithTagsDetail = items
    state.calledBefore = true
  },
  clearAnswersWithTagsDetail (state,items){
    state.AnswersWithTagsDetail = items;
  }
}
export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/editquestion/edit.js